// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrors = {
  apiCodeUnknown: "Request failed for error code {code}",
} as const;
